/*
Basic link card found on the Dashboard page.
Props: Title, Subtitle, Link, and Icon
Icons use Material font icons: https://material.io/resources/icons/?style=baseline
 */

//import React from 'react';
import PropTypes from 'prop-types';
//import { makeStyles } from "@mui/styles";
import {Grid, Card, CardContent, Typography, CssBaseline} from '@mui/material';
import Icon from '@mui/material/Icon'
//import {useTheme} from "@mui/material/styles";
import { grey } from '@mui/material/colors';
//import LinkCardStyles from "../../styles/jss/components/common/LinkCardStyles";
import { useNavigate  } from "react-router-dom";
import ErrorBoundary from './ErrorBoundary';

//const useStyles = makeStyles(LinkCardStyles);

const LinkCard = (props) => {
    const {title, subtitle, link, icon} = props;
    //const classes = useStyles();
    //const theme = useTheme();
    const navigate = useNavigate();
    return(
      <ErrorBoundary fallback={<p>Something went wrong</p>}>
        <Grid container>
          <Grid size={{ xs: 12, md: 6, lg: 3 }} sx={{ display: 'flex', justifyContent: 'center' }}>
              <CssBaseline/>
              <Card onClick={() => navigate(link)} sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                justifyContent: 'center',
                cursor: 'pointer',
                // figure out where this background color is coming from? Not in palette.
                '&:hover': {
                    backgroundColor: "#DAE6F7"
                }
              }}>
                  <CardContent sx={{justifyContent: 'center', textAlign: 'center' }}>
                      <Icon color={grey[3]} sx={{
                        fontSize: '48px',
                        marginBottom: '8px',
                        color: grey[700],
                      }}>{icon}</Icon>
                      <Typography variant={'h6'} sx={{ color: '#0050C8' }} >
                          {title}
                      </Typography>
                      <Typography variant={'body2'} sx={{ color: grey[700] }}>
                          {subtitle}
                      </Typography>
                  </CardContent>
              </Card>
          </Grid>
        </Grid>
      </ErrorBoundary>
    );
};

LinkCard.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    link: PropTypes.string,
    icon: PropTypes.string
};

LinkCard.defaultProps = {
    title: "Title",
    subtitle: "Subtitle",
    link: '/apps',
    icon: 'apps'
};

export default LinkCard;

